module.exports = __webpack_public_path__ + "static/img/00index1_16.bdb7623.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ew/00index1_16.jpg
// module id = TDU/
// module chunks = 0